import { LocalStorageManager } from '@helpers/utils';

export const LOCAL_STORAGE_NAMESPACE = 'web';

export const LOCAL_STORAGE_KEY = {
  KEYCLOAK_LANGUAGE: 'keycloakLanguage',
  LANGUAGE: 'language',
} as const;

export const lsManager = new LocalStorageManager(LOCAL_STORAGE_NAMESPACE, LOCAL_STORAGE_KEY);
